import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkQuestionsComplete } from "../../../features/mobile/otherSlice";
import { onResetAll } from "../../../features/mobile/infoSlice";
import MenuBar from "../components/common/MenuBar";
import TagManager from "react-gtm-module";
import { mobileTypeFn } from "../../mobile/components/logic";
import { checkMinVersion } from "../../mobile/components/logic";
import ProgressBar from "../components/meal/ProgressBar";
import KcalGraph from "../components/common/KcalGraph";
import Btn from "../components/common/Btn";
import HealthInfoComponent from "./question/HealthInfoComponent";
import dayjs from "dayjs";
import BarChart from "../components/common/BarChart";
import { useSwipeable } from "react-swipeable";
import { CalorieSwipe, ProteinSwipe, WeightSwipe } from "./SwipePage";
import Tutorial from "./Tutorial";
import CalendarHeader from "../components/common/CalendarHeader";
import {
  fetchMain,
  fetchMainPoints,
  onSaveTodayStep,
} from "../../../features/mobile/mainSlice";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  fetchDrugSchedule,
  scheduleCheck,
} from "../../../features/mobile/drugSlice";
import Dialog from "../components/common/Dialog";

const Home = () => {
    const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { loginInfo, tutorialEnabled, chosenDate } = useSelector(
    (state) => state.commonApp
  );
  const { questionsCompleteCheck } = useSelector((state) => state.others);
  // console.log(questionsCompleteCheck, "questionsCompleteCheck");
  const { prevPostList } = useSelector((state) => state.info);
  const healthInfoRef = useRef(null);

  // const [step, setStep] = useState(0);

  const [startDate, setStartDate] = useState(
    dayjs(new Date()).format("YYYY-MM-DD")
  );
  const {
    todayStep,
    steps,
    weights,
    weight,
    symptoms,
    medicines,
    treatments,
    eat,
    existMainPointOfYear,
    mealDates,
    otherRecordDates,
  } = useSelector((state) => state.mainData);
  const { dayDrugLists } = useSelector((state) => state.drug);

  const now = new Date();
  const month = now.toLocaleString("ko-KR", { month: "long" });

  const [tutorialState, setTutorialState] = useState(false);

  const [healthResult, setHealthResult] = useState(
    location.state?.healthResult
  );
  const [isLoading, setIsLoading] = useState(true); // kcal graph state
  const [openDialog, setOpenDialog] = useState(false); // step counter popup state

  const [checkStep, setCheckStep] = useState({ step: false, type: "" });
  // const [checkAosStep, setCheckAosStep] = useState(false);
  const [checkNoti, setCheckNoti] = useState(false);

  // swipe current index
  const [currentIndex, setCurrentIndex] = useState(0);
  const healthTotalScreens = 3;
  // swipe screen array
  const screens = [
    <WeightSwipe
      currentIndex={currentIndex}
      totalScreens={healthTotalScreens}
      weight={weight}
      weights={weights}
    />,
    <CalorieSwipe
      currentIndex={currentIndex}
      totalScreens={healthTotalScreens}
      kcals={eat?.kcals}
      recommendedCalories={eat?.recommendedCalories}
    />,
    <ProteinSwipe
      currentIndex={currentIndex}
      totalScreens={healthTotalScreens}
      proteinGs={eat?.proteinGs}
      recommendedProteinGs={eat?.recommendedProteinGs}
    />,
  ];

  // swipe handler logic
  const handlers = useSwipeable({
    onSwipedLeft: () => {
      // swiping right on the last screen returns to the first screen
      const newIndex =
        currentIndex === healthTotalScreens - 1 ? 0 : currentIndex + 1;
      setCurrentIndex(newIndex);
    },
    onSwipedRight: () => {
      // swiping left on the first screen goes to the last screen
      const newIndex =
        currentIndex === 0 ? healthTotalScreens - 1 : currentIndex - 1;
      setCurrentIndex(newIndex);
    },
  });

  // show all medications
  const filterDrugLists = dayDrugLists;

  useEffect(() => {
    setIsLoading(true); // set loading state before data request
    // dispatch(
    //   fetchMain({
    //     userId: loginInfo.userId,
    //     day: chosenDate || startDate,
    //   })
    // );
    // dispatch(
    //   fetchDrugSchedule({
    //     userId: loginInfo.userId,
    //     date: chosenDate || startDate,
    //   })
    // );
    // Promise - wait for parallel tasks to complete / fix animation to work properly
    async function fetchData() {
      await Promise.all([
        dispatch(
          fetchMain({
            userId: loginInfo.userId,
            day: chosenDate || startDate,
          })
        ),
        dispatch(
          fetchDrugSchedule({
            userId: loginInfo.userId,
            date: chosenDate || startDate,
          })
        ),
      ])
        .then(() => {
          setIsLoading(false); // release loading state after all data is loaded
        })
        .catch((error) => {
          console.error("Failed to load main data or medication schedule:", error);
        });
    }
    fetchData();
  }, [chosenDate]);

  useEffect(() => {
    window.nowStep = (params) => {
      const object = JSON.parse(params);
      const value = object.value;
      dispatch(onSaveTodayStep(value));
    };

    if (location.state?.healthResult) {
      window.scrollTo({
        top: healthInfoRef?.current?.offsetTop - 20,
        left: 0,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, []);

  useEffect(() => {
    if (!questionsCompleteCheck || Object.keys(questionsCompleteCheck).length === 0) {
      // check survey completion status
      dispatch(checkQuestionsComplete(loginInfo.userId));
    }

    // eslint-disable-next-line
  }, [dispatch, loginInfo.userId]);

  useEffect(() => {
    dispatch(
      fetchMainPoints({
        userId: loginInfo.userId,
        year: dayjs(chosenDate || startDate).format("YYYY"),
      })
    );
  }, [chosenDate, dayjs(startDate).format("YYYY")]);

  let firebaseToken = window.sessionStorage.getItem("token");

  // Scroll to top on page load - enhanced for physical iPhone devices
  useEffect(() => {
    // Multiple methods to ensure scroll to top works on all devices
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Delay for iOS rendering
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 0);
  }, []);

  useEffect(() => {
    const tagManagerArgs = {
      // tag manager
      gtmId: "GTM-N3XGGSS",
      dataLayer: {
        event: "login_token",
        value: firebaseToken || loginInfo.snsId || null,
      },
      dataLayerName: "dataLayer",
    };

    TagManager.dataLayer(tagManagerArgs);
    TagManager.dataLayer({
      gtmId: "GTM-MHZ2ZXDV",
      dataLayer: {
        event: "login_token",
        value: firebaseToken || loginInfo.snsId || null,
      },
      dataLayerName: "dataLayer",
    });

    // console.log(questionsCompleteCheck);

    // Check for authentication - verify both Redux state and localStorage token
    // This prevents race condition on slower devices (iPads) where Redux state
    // might not be updated yet when component mounts after login
    const hasAccessToken = localStorage.getItem('accessToken');

    if (!loginInfo?.userId && !hasAccessToken) {
      // No userId AND no accessToken → Not authenticated → Redirect to /sign
      navigate(`/sign`);
      return;
    }

    // If we have a token but loginInfo is not loaded yet, skip the rest
    // The next render cycle will have loginInfo populated
    if (!loginInfo?.userId && hasAccessToken) {
      // User just logged in, token is saved, Redux is updating
      // Return early to prevent further code execution
      return;
    }

    // User is authenticated and loginInfo is available - proceed normally
    if (loginInfo?.userId) {
      // Rest of the authentication flow
      if (prevPostList?.length > 0) dispatch(onResetAll());
      console.log(questionsCompleteCheck, "questionsCompleteCheck");
      if (
        (questionsCompleteCheck &&
          Object.keys(questionsCompleteCheck)?.length === 0) ||
        (questionsCompleteCheck && questionsCompleteCheck?.openTutorial3) ||
        (questionsCompleteCheck && !questionsCompleteCheck?.eatRecordComplete)
      ) {
        // Check whether to show survey or not
        // showSurvey();
        // check survey status if not checked (re-fetch in case tutorial was completed or meal was recorded)
        dispatch(checkQuestionsComplete(loginInfo?.userId))
          .unwrap()
          .then((res) => {
            if (res.ok) {
              // send user unique key to tag manager from home
              const gaKey = res.gaKey;
              window.dataLayer.push({
                event: "login",
                user_id: gaKey,
              });
              if (res.openTutorial3) {
                // show tutorial for 3 days after sign-up

                if (tutorialEnabled) {
                  setTutorialState(true);
                }
              }
            }
          })
          .catch((err) => console.log(err));
      } else {
        if (questionsCompleteCheck && questionsCompleteCheck?.openTutorial3) {
          // show tutorial for 3 days after sign-up
          if (tutorialEnabled) {
            setTutorialState(true);
          }
        }
      }
    }
    // eslint-disable-next-line
  }, [dispatch, loginInfo.userId, navigate, tutorialState, setTutorialState]);

  useEffect(() => {
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler("setUserId", loginInfo.userId);
    }

    if (mobileTypeFn() === "iphone") {
      window.flutter_inappwebview
        ?.callHandler("getIosVersion")
        .then(function (result) {
          // alert(result);
          window.flutter_inappwebview.callHandler("mainLoaded");
          const needUpdate = checkMinVersion(result, "2.0.21");
          if (!needUpdate) {
            window.flutter_inappwebview
              ?.callHandler("isAuthStep")
              .then((res) => {
                if (res) {
                  setCheckStep({ ...checkStep, step: true, type: "ios" });
                } else {
                  setCheckStep({ ...checkStep, step: false, type: "ios" });
                }
              });
          }
        });
    }

    if (mobileTypeFn() === "android") {
      window.flutter_inappwebview
        ?.callHandler("getAndroidVersion")
        .then(function (result) {
          // alert(result);
          window.flutter_inappwebview?.callHandler("mainLoaded");
          const needUpdate = checkMinVersion(result, "2.0.21");
          if (!needUpdate) {
            // alert("14 or higher");
            window.flutter_inappwebview
              ?.callHandler("isAuthStep")
              .then((res) => {
                if (res) {
                  setCheckStep({ ...checkStep, step: true, type: "aos" });
                } else {
                  setCheckStep({ ...checkStep, step: false, type: "aos" });
                }
              });
            window.flutter_inappwebview
              ?.callHandler("isNotification")
              .then((res) => {
                if (res) {
                  setCheckNoti(true);
                } else {
                  setCheckNoti(false);
                }
              });
          }
        });
    }
  }, []);

  window?.flutter_inappwebview?.callHandler("getIosVersion").then((res) => {
    if (Number(res.split(".")[2]) >= 21) {
      window.flutterResumeEvent = () => {
        if (mobileTypeFn() === "iphone") {
          window.flutter_inappwebview?.callHandler("isAuthStep").then((res) => {
            if (res) {
              setCheckStep({ ...checkStep, step: true, type: "ios" });
            } else {
              setCheckStep({ ...checkStep, step: false, type: "ios" });
            }
          });
        }

        if (mobileTypeFn() === "android") {
          window.flutter_inappwebview?.callHandler("isAuthStep").then((res) => {
            if (res) {
              setCheckStep({ ...checkStep, step: true, type: "aos" });
            } else {
              setCheckStep({ ...checkStep, step: false, type: "aos" });
            }
          });
          window.flutter_inappwebview
            ?.callHandler("isNotification")
            .then((res) => {
              if (res) {
                setCheckNoti(true);
              } else {
                setCheckNoti(false);
              }
            });
        }
        return "success!!!!!!!!!!!!";
      };
    }
  });

  // move to app settings
  const moveSetting = () => {
    if (window?.flutter_inappwebview) {
      if (checkStep.type === "aos" && checkNoti === false) {
        window?.flutter_inappwebview?.callHandler("setNotification");
      } else if (checkStep.type === "aos" && checkStep.step === false) {
        window?.flutter_inappwebview?.callHandler("appSetting");
      } else if (checkStep.type === "ios" && checkStep.step === false) {
        window?.flutter_inappwebview?.callHandler("appSettingIOS");
      }
    }
    setOpenDialog(false);
  };

  // convert time:minute string to 12-hour format - medication reminder
  const timeIn12HourFormat = (time) => {
    let [hour, minute] = time.split(":").map(Number);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // 0 hour is 12 AM, hours >= 12 display as PM
    return `${ampm} ${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
  };

  return (
    <>
      <CalendarHeader
        type={"RECORD_COMPLETE"}
        startDate={startDate}
        setStartDate={setStartDate}
        chosenDate={chosenDate === null ? startDate : chosenDate}
        // setChosenDate={setChosenDate}
        existDaysOfYear={[...existMainPointOfYear]}
        mealDates={[...(mealDates || [])]}
        otherRecordDates={[...(otherRecordDates || [])]}
      />

      <div className="-mt-7 h-auto w-full rounded-tl-[28px] bg-back_ground p-[10px] pb-[160px] ">
        {questionsCompleteCheck?.openTutorial3 !== true ? (
          <>
            <div className="mb-4 flex w-full flex-col gap-[10px] p-[10px]">
              <div className="text-xl font-bold text-black">{"Meal Log"}</div>

              <ProgressBar
                title={"Calorie Goal"}
                data={eat?.recommendedCalorie}
                data2={eat?.kcal}
                unit={"kcal"}
                // progress={50}
                bgColor={"bg-[#C9DBFF]"}
                innerColor={"bg-[#8744E1]"}
                textColor={"text-white"}
              />
              <ProgressBar
                title={"Protein Goal"}
                data={eat?.recommendedProteinG}
                data2={eat?.proteinG}
                unit={"g"}
                // progress={50}
                bgColor={"bg-[#ABE7FA]"}
                innerColor={"bg-[#51CCF3]"}
                textColor={"text-white"}
              />

              <div className="flex w-full flex-col items-start gap-[10px]">
                <div className="w-full">
                  <span className="text-center font-semibold tracking-tight text-gray_160">
                    {"Calories by Meal"}
                  </span>
                  <span className="ml-2 text-sm font-medium tracking-tight text-[#7A7A7A]">
                    {"(Unit: kcal)"}
                  </span>
                </div>
                <div className="flex w-full items-center gap-[10px] py-[10px]">
                  <KcalGraph
                    isLoading={isLoading}
                    datas={{
                      bkcal: eat?.bkcal || 0,
                      bskcal: eat?.bskcal || 0,
                      lkcal: eat?.lkcal || 0,
                      lskcal: eat?.lskcal || 0,
                      dkcal: eat?.dkcal || 0,
                      dskcal: eat?.dskcal || 0,
                    }}
                  />
                </div>
              </div>
              <div className="mx-2">
                <Btn
                  id={"mealRecord"}
                  bgColor={"bg-main"}
                  textColor={"text-white font-bold"}
                  borderColor={"border border-main"}
                  title={"Log Meal"}
                  active={"on"}
                  onAction={() => {
                    if (questionsCompleteCheck?.healthComplete) {
                      navigate("/meal/record");
                    } else {
                      navigate("/question/health");
                    }
                  }}
                />
              </div>
            </div>
            {questionsCompleteCheck?.healthComplete ? (
              <div ref={healthInfoRef}>
                <HealthInfoComponent
                  healthResult={healthResult}
                  setHealthResult={setHealthResult}
                />
              </div>
            ) : null}

            <div className="mt-4 grid grid-cols-2 items-start gap-2.5 pb-5 pt-4">
              {/* weight, calories, protein */}

              <div {...handlers} className="w-full overflow-hidden">
                <div
                  className="flex w-full transition-transform duration-300"
                  style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                >
                  {screens.map((Screen, index) => (
                    <div key={index} className="w-full flex-shrink-0">
                      {Screen}
                    </div>
                  ))}
                </div>
              </div>

              {/* symptoms */}
              <div
                className="h-full rounded-xl bg-white px-4 py-2.5"
                onClick={() => {
                  if (questionsCompleteCheck?.healthComplete) {
                    navigate("/symptom/record");
                  } else {
                    navigate("/question/health");
                  }
                }}
              >
                <div className="flex w-full flex-col">
                  <div className="text-xl font-bold text-black ">{"Symptoms"}</div>
                  {symptoms?.length > 0 && (
                    <div className="text-[15px] font-semibold text-neutral-400">
                      {symptoms?.length} symptom{symptoms?.length === 1 ? '' : 's'} added
                    </div>
                  )}
                </div>

                {symptoms?.length > 0 ? (
                  <div className="flex w-full flex-row flex-wrap gap-2.5 pt-4">
                    {symptoms.map((arr, index) => {
                      return index <= 2 ? (
                        <div
                          key={arr}
                          className="items-center justify-center rounded-lg bg-indigo-400 4sm:p-[5px] 3sm:p-[10px] 2sm:p-[8px]"
                        >
                          <p className="font-['NanumSquare Neo'] flex text-xs font-bold text-white">
                            {arr}
          </p>
                        </div>
                      ) : index === 3 ? (
                        <div
                          key={arr}
                          className="flex items-center justify-center gap-2.5 rounded-lg bg-indigo-400 p-2.5"
                        >
                          <div className="font-['NanumSquare Neo'] flex text-xs font-bold text-white">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="5"
                              viewBox="0 0 20 5"
                              fill="none"
                            >
                              <circle cx="2" cy="2.5" r="2" fill="white" />
                              <circle cx="10" cy="2.5" r="2" fill="white" />
                              <circle cx="18" cy="2.5" r="2" fill="white" />
                            </svg>
                          </div>
                        </div>
                      ) : null;
                    })}
                  </div>
                ) : (
                  <>
                    <p className="mt-2 text-[15px] font-medium leading-[18px] text-gray_140">
                      {"Any symptom today?"}
                    </p>
                    <div className="flex h-full w-full justify-center pt-8">
                      <img
                        src={"/images/mobile/icon/empty_img.svg"}
                        alt="Empty state image"
                        className="h-12 w-12"
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 items-start gap-2.5 pb-5">
              {/* steps */}
              <div className="flex w-full items-start gap-2.5">
                {(checkStep.type === "ios" && checkStep.step === false) ||
                (checkStep.type === "aos" &&
                  (checkStep.step === false || checkNoti === false)) ? (
                  <div className="flex h-[218px] w-full flex-col items-start gap-9 overflow-hidden rounded-xl bg-white px-4 py-2.5">
                    <div className="flex flex-col">
                      <p className="text-xl font-bold text-black">{"Steps"}</p>
                      <p className="mr-2 text-sm font-medium text-neutral-500">
                        {"Step tracking is disconnected"}
                      </p>
                    </div>
                    <button
                      className="mt-4 w-full items-center justify-center gap-2.5 rounded-md bg-[#FE718E] p-2.5"
                      onClick={() => setOpenDialog(true)}
                      // onClick={() => navigate("/step")}
                    >
                      <p className="text-lg font-semibold text-white">
                        {"Connect"}
                      </p>
                    </button>
                  </div>
                ) : (
                  <>
                    <div
                      className="flex h-[218px] w-full flex-col items-start gap-9 overflow-hidden rounded-xl bg-white px-4 py-2.5"
                      onClick={() => navigate("/step")}
                    >
                      <div className="text-xl font-bold text-black">
                        {"Steps"}
                        <div className="flex gap-1">
                          <p className="text-[22px] font-semibold leading-[29px] text-black">
                            {todayStep || 0}
                          </p>
                          <p className="line flex items-end text-[16px] font-semibold text-black">
                            {"steps"}
                          </p>
                        </div>
                        <div className="flex ">
                          <p className="mr-2 text-sm font-medium text-neutral-500">
                            {"Compared to yesterday"}
                          </p>
                          <img
                            src={"/images/mobile/icon/upIconRed.svg"}
                            alt="upIcon"
                            className={`mr-1 ${
                              todayStep - steps[steps?.length - 1] < 0 &&
                              "rotate-180"
                            }`}
                          />
                          <div className="text-sm font-medium text-[#FF4646]">
                            {Math.abs(todayStep - steps[steps?.length - 1])}
                          </div>
                        </div>
                      </div>

                      <div className="-ml-8 mt-5 flex h-14 w-full items-end gap-2">
                        <BarChart
                          dataName={"Steps"}
                          actualData={steps}
                          step={todayStep}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
              {/* medication reminder */}
              <div
                className="flex w-full items-start gap-2.5"
                onClick={() => navigate("/drugalarm")}
              >
                <div className="flex h-[218px] w-full flex-col items-start gap-9 rounded-xl bg-white px-4 py-2.5">
                  <div className="flex w-full flex-col items-start gap-2">
                    <div className="flex w-full flex-col">
                      <div className="flex w-full items-center justify-between">
                        <div className="text-xl font-bold text-black">
                          {"Medication Reminder"}
                        </div>
                        {filterDrugLists?.length > 1 && (
                          <div className="text-[15px] font-semibold text-neutral-400">
                            {filterDrugLists.length} medications
                          </div>
                        )}
                      </div>

                      {filterDrugLists?.length > 0 ? (
                        <Swiper
                          spaceBetween={50}
                          slidesPerView={1}
                          className="my-8 h-full w-full"
                        >
                          {filterDrugLists?.map((medicine) => (
                            <SwiperSlide
                              key={
                                medicine.schedule_id + medicine.id + medicine.n
                              }
                              className="flex h-full w-full flex-col items-center gap-2.5"
                            >
                              <div className="w-full truncate text-center text-xl font-bold text-neutral-700">
                                {medicine.name}
                              </div>
                              <div className="flex w-full flex-row items-center justify-center gap-1.5">
                                <img
                                  src={"/images/mobile/icon/alarm_clock.svg"}
                                  alt="Alarm clock"
                                />
                                <div className="font-neo text-[15px] text-neutral-400">
                                  {timeIn12HourFormat(
                                    `${medicine.hour}:${medicine.minute}`
                                  )}
                                </div>
                              </div>
                              <div
                                className={`flex w-[95px] items-center justify-center gap-2.5 rounded-[60px] px-4 py-2 font-neo text-sm font-bold ${
                                  medicine.check
                                    ? "bg-[#01B68B] text-white"
                                    : "border border-[#01B68B] bg-white text-[#01B68B] active:bg-[#01B68B] active:text-white"
                                }`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  dispatch(
                                    scheduleCheck({
                                      userId: loginInfo.userId,
                                      id: medicine.id,
                                      date: chosenDate || startDate,
                                      n: medicine.n,
                                      check: !medicine.check,
                                    })
                                  )
                                    .unwrap()
                                    .then((res) => {
                                      if (res.ok) {
                                        dispatch(
                                          fetchDrugSchedule({
                                            userId: loginInfo.userId,
                                            date: chosenDate || startDate,
                                          })
                                        );
                                      }
                                    });
                                }}
                              >
                                {medicine.check ? "Taken" : "Scheduled"}
                              </div>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      ) : (
                        <>
                          <p className="mt-2 text-[15px] font-medium leading-[18px] text-gray_140">
                            {"Time for your medication?"}
                          </p>
                          <div className="flex h-full w-full justify-center pt-8">
                            <img
                              src={"/images/mobile/icon/empty_img.svg"}
                              alt="Empty state image"
                              className="h-12 w-12"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="flex flex-col items-center gap-[14px] rounded-xl bg-white px-4 py-2.5"
              onClick={() => navigate("/treatment")}
            >
              <div className="flex w-full items-center justify-between">
                <div className="text-xl font-bold text-black">
                  {treatments?.length > 0 ? "Appointment Reminder" : "Appointment Schedule"}
                </div>
                <div className="text-[15px] font-semibold text-neutral-400">
                  {treatments?.length > 0 ? `${treatments.length} ${treatments.length === 1 ? 'appointment' : 'appointments'}` : null}
                </div>
              </div>

              <div className="flex-start flex w-full gap-2">
                {treatments?.length > 0 ? (
                  <Swiper
                    // modules={[Pagination]}
                    spaceBetween={50}
                    slidesPerView={1}
                    className="h-full w-full"
                    // pagination={{ clickable: true }}
                  >
                    {treatments?.map((treatment, index) => {
                      const { name, time, period, hour, minute } = treatment;
                      return (
                      <SwiperSlide
                        key={index}
                        className="flex h-full w-full gap-2.5"
                      >
                        <div className="h-[75px] w-1.5 rounded-[5px] bg-sky-400" />
                        <div className="flex-start flex w-full flex-col gap-0">
                          <span className="text-lg font-semibold text-black">
                            {`You have an appointment at ${name} on ${time} at ${period} ${hour}:${minute}`}
                          </span>
                          <span className="text-base font-semibold text-neutral-400">
                            {dayjs(chosenDate || startDate).format(
                              "YYYY-MM-DD ddd"
                            )}
                          </span>
                        </div>
                      </SwiperSlide>
                      );
                    })}
                  </Swiper>
                ) : (
                  <div className="my-2 flex w-full justify-between">
                    <p className="text-[15px] font-medium leading-[18px] text-gray_140">
                      {"Track your appointments and never miss one!"}
                    </p>
                    <img
                      src={"/images/mobile/icon/empty_img.svg"}
                      alt="Empty state image"
                      className="-mt-7 mr-6 h-12 w-12"
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          <Tutorial setTutorialState={setTutorialState} />
        )}
      </div>
      {/* step counter popup */}
      {
        openDialog &&
          // IOS
          (checkStep.type === "ios" && checkStep.step === false ? (
            <Dialog
              innerClass={"p-6"}
              title={"Step Tracking Permission"}
              desc={"Enable step tracking in <span class=\"font-bold\">Settings → Health → Data Access & Devices → Healiary → Steps</span>"}
              leftBtnTitle={"Confirm"}
              rightBtnTitle={"Close"}
              onLeftBtnAction={() => moveSetting()}
              onRightBtnAction={() => setOpenDialog(false)}
              onCoverAction={() => setOpenDialog(false)}
            />
          ) : checkStep.type === "aos" && checkNoti === false ? (
            <Dialog
              innerClass={"p-6"}
              title={"Notification Permission"}
              desc={"Required for step tracking"}
              leftBtnTitle={"Agree"}
              rightBtnTitle={"Close"}
              onLeftBtnAction={() => moveSetting()}
              onRightBtnAction={() => {
                setOpenDialog(false);
              }}
              onCoverAction={() => {
                setOpenDialog(false);
              }}
            />
          ) : checkStep.type === "aos" && checkStep.step === false ? (
            <Dialog
              innerClass={"p-6"}
              title={"Physical Activity Permission"}
              desc={"Required for step tracking"}
              leftBtnTitle={"Agree"}
              rightBtnTitle={"Close"}
              onLeftBtnAction={() => moveSetting()}
              onRightBtnAction={() => {
                setOpenDialog(false);
              }}
              onCoverAction={() => {
                setOpenDialog(false);
              }}
            />
          ) : null)

        // AOS
      }

      <MenuBar />
      {/* {askSurvey && (
      <SurverDialog
        nickName={loginInfo?.nickName}
        onSurveyAction={onSurveyAction}
      />
    )} */}
    </>
  );
};

export default Home;
